import { BrowserModule } from '@angular/platform-browser'
import { NgModule, ErrorHandler } from '@angular/core'
import localeEn from '@angular/common/locales/en'
import localeSk from '@angular/common/locales/sk'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { BASE_PATH, ApiModule } from '@resultsgate-ui/api'
import { CoreModule, MissingI18nService, SentryErrorHandler, Environment } from '@resultsgate-ui/shared'
import { NgxDatatableModule } from '@swimlane/ngx-datatable'
import { CollapseModule } from 'ngx-bootstrap/collapse'
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker'
import { ModalModule } from 'ngx-bootstrap/modal'
import { NgxPrintModule } from 'ngx-print'
import { ToastrModule } from 'ngx-toastr'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { registerLocaleData } from '@angular/common'
import { HttpClient, HttpClientModule } from '@angular/common/http'
import { DashboardComponent } from './dashboard/dashboard.component'
import { ChartModule } from 'primeng/chart'
import { CalendarModule } from 'primeng/calendar'

import { environment } from '../environments/environment'
import { defineLocale } from 'ngx-bootstrap/chronos'
import { csLocale, skLocale } from 'ngx-bootstrap/locale'
defineLocale('sk', skLocale)
defineLocale('cz', csLocale)
// import { GlobalErrorHandler } from './app-error-handler.service'
registerLocaleData(localeSk)
registerLocaleData(localeEn)
// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json')
}

@NgModule({
    declarations: [AppComponent, DashboardComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        ApiModule,
        AppRoutingModule,
        NgxPrintModule,
        NgxDatatableModule,
        AppRoutingModule,
        CoreModule,
        BsDatepickerModule.forRoot(),
        CollapseModule.forRoot(),
        ModalModule.forRoot(),
        ChartModule,
        CalendarModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: MissingI18nService,
            },
        }),
        ToastrModule.forRoot(),
    ],
    providers: [
        {
            provide: BASE_PATH,
            useValue: './api',
        },
        { provide: Environment, useValue: environment },
        { provide: ErrorHandler, useClass: environment.production ? SentryErrorHandler : null },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
